import ScannerDocumentConfig, {
  ScanDocumentSidesMode,
} from "models/scanner-document-config";

import { ScannerOverlayState } from "../DocumentCapture";

const getScanningStages = (
  docScannerConfig: ScannerDocumentConfig
): ScannerOverlayState[] => {
  if (docScannerConfig.mode === ScanDocumentSidesMode.OnlyDataPage) {
    return [ScannerOverlayState.ScanningDataPage];
  }

  if (
    docScannerConfig.mode === ScanDocumentSidesMode.CardFrontOrDataPage ||
    docScannerConfig.mode === ScanDocumentSidesMode.OnlyCardFront
  ) {
    return [
      ScannerOverlayState.BeforeScanningFrontSide,
      ScannerOverlayState.ScanningFrontSide,
    ];
  }

  if (
    docScannerConfig.mode === ScanDocumentSidesMode.CardBackOrDataPage ||
    docScannerConfig.mode === ScanDocumentSidesMode.OnlyCardBack
  ) {
    return [
      ScannerOverlayState.BeforeScanningBackSide,
      ScannerOverlayState.ScanningBackSide,
    ];
  }

  // default - all
  return [
    ScannerOverlayState.BeforeScanningFrontSide,
    ScannerOverlayState.ScanningFrontSide,
    ScannerOverlayState.BeforeScanningBackSide,
    ScannerOverlayState.ScanningBackSide,
  ];
};

export default getScanningStages;
